













































































import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop, Watch } from 'vue-property-decorator';
import { Global, User, Schedules } from '@/store';
import CurvesList from './CurvesList.vue';
import Calendar from './Calendar.vue';
import CurvesDialog from './CurvesDialog.vue';
import NewCurve from './curves/NewCurve.vue';
import PropEditor from '@/components/PropEditor.vue';
import MessageDialog from '@/components/dialogs/MessageDialog.vue';
import ConfirmDialog from '@/components/dialogs/ConfirmDialog.vue';
import { Types } from '@/modules/API';

@Component({
  components: {
    CurvesList,
    CurvesDialog,
    NewCurve,
    Calendar,
    PropEditor,
    MessageDialog,
    ConfirmDialog
  }
})
class CurveSelection extends Vue {
    @Global.State('readonly_user') readonly_user;
    @Global.State('lang') lang;
    @User.State('project') project;
    @Schedules.State('userCurves') userCurves;
    @Schedules.State('schedules') schedules;
    @Schedules.Action('deleteCurve') deleteCurve;
    @Schedules.Action('runSchedulerInServer') runSchedulerInServer;

    @Prop() activeCurve;
    @Prop() setActiveCurveData;
    @Prop() setSchedule;
    @Prop() schedule;
    @Prop() updateScheduleCurves;
    @Prop() curves_map;
    @Prop() schedule_curves_map;

    curvesDialog = false;
    selectedCurves = [];
    unselectedCurves = [];
    dataCurve = null;
    curveClicked = false;
    is_days_selected = false;
    deleteInfoDialog = false;
    confirmDeleteDialog = false;
    message = `You must remove this curve from the following schedules before delete`;
    list_info = [];
    delete_curve_id = '';
    CREATE_CURVE_QUERY = 'new';
    curve_query_pushed = false;
    $refs!: { 
        propEditor: InstanceType<typeof PropEditor>
    };

    mounted(){
        this.setSelectedCurves();
        this.checkDaysSelected();
        this.syncCurveFromQuery();
    }

    @Watch('userCurves')
    setSelectedCurves(){
        if (this.schedule.curves.length){
            this.unselectedCurves = [];
            this.userCurves.forEach((curve) => {
                if (this.schedule_curves_map.has(curve.id)) {
                    const index = this.selectedCurves.findIndex((selected_curve) => selected_curve.id === curve.id);
                    if (index === -1) this.selectedCurves.push(curve);
                }
            });
        }
        const curve_ids = [...this.curves_map.keys()];
        this.selectedCurves = this.selectedCurves.filter((curve) => curve_ids.includes(curve.id));
        this.unselectedCurves = this.userCurves.filter((curve) => this.selectedCurves.findIndex((selected_curve) => selected_curve.id === curve.id) === -1);
    }

    @Watch('schedule.curves')
    checkDaysSelected(){
        this.is_days_selected = this.schedule.curves && this.schedule.curves.length > 0;
    }
    
    removeNotLinkedCurve(curve){
        this.selectedCurves = this.selectedCurves.filter((selected_curve) => selected_curve.id !== curve.id);
        this.unselectedCurves.push(curve);
        if (this.activeCurve.id === curve.id) this.setActiveCurveData({id: '', color: ''});
    }

    checkCurveInUse(curve_id){
        const schedules_in_use = [];
        this.list_info = [];
        this.schedules.forEach((schedule) => {
            if (schedule.id !== this.schedule.id && schedule.curves.some((date_curve) => date_curve.id === curve_id)) {
                schedules_in_use.push(schedule.name);
            }
        });
        this.setDeleteInfoDialog(schedules_in_use.length > 0);
        if (this.deleteInfoDialog) this.list_info = schedules_in_use;
        if (!this.deleteInfoDialog){
            this.confirmDeleteDialog = true;
            this.delete_curve_id = curve_id;
        }
    }

    async deleteSelectedCurve(){
        await this.deleteCurve(this.delete_curve_id);
        this.updateScheduleCurves(this.schedule.curves.filter((curve) => curve.id !== this.delete_curve_id));
        this.$refs.propEditor.save(this.userCurves, {
                name: 'dashboard.curves',
                objectID: this.project.id,
                objectType: Types.PROJECTS
            }, 
            () => this.runSchedulerInServer(), 
            'Curve Deleted Successfully'
        );
        this.confirmDeleteDialog = false;
        this.delete_curve_id = '';
        this.setCurveClicked(false);
        this.setActiveCurveData({id: '', color: ''});
    }

    setDeleteInfoDialog(is_open){
        this.deleteInfoDialog = is_open;
    }

    updateSelctedCurves(new_selected){
        let new_selected_index = -1;
        // when updating selected curve after create/edit curve
        if (new_selected.length === 1){
            new_selected_index = this.selectedCurves.findIndex((curve) => curve.id === new_selected[0].id);
        }
        this.selectedCurves = new_selected_index > -1
            ? this.selectedCurves.filter((curve) => curve.id !== new_selected[0].id).concat(new_selected)
            : this.selectedCurves.concat(new_selected);
        this.unselectedCurves = this.unselectedCurves.filter((curve) => new_selected.findIndex((new_selected_curve) => new_selected_curve.id === curve.id) === -1);
    }

    /*
      The curve editor stays an overlay on this step instead of becoming its own route:
      the schedule being built lives in this page's memory and is only persisted by
      "Save Schedule", so leaving /schedules/:id would throw the draft away. The open
      curve is reflected in the query (?curve=<id> / ?curve=new) so the URL matches what
      is on screen and Back closes the editor rather than abandoning the schedule.
    */
    setCurveClicked(clicked, id?){
        this.setCurveState(clicked, id);
        clicked ? this.addCurveQuery(id) : this.removeCurveQuery();
    }

    setCurveState(clicked, id?){
        this.curveClicked = clicked;
        this.setCurveData(id);
    }

    /* Back / Forward and a reopened link all arrive here rather than through a click. */
    @Watch('$route.query.curve')
    syncCurveFromQuery(){
        const curve_query = this.$route.query.curve;
        if (!curve_query) {
            if (this.curveClicked) this.setCurveState(false);
            return;
        }

        const curve_id = curve_query === this.CREATE_CURVE_QUERY ? undefined : `${curve_query}`;
        // A curve that is not part of this project (deleted, or a link from elsewhere)
        // has nothing to open, so the query is dropped instead of showing an empty editor.
        if (curve_id && !this.curves_map.has(curve_id)) {
            this.removeCurveQuery();
            return;
        }
        this.setCurveState(true, curve_id);
    }

    addCurveQuery(id?){
        const curve = id || this.CREATE_CURVE_QUERY;
        if (this.$route.query.curve === curve) return;
        this.curve_query_pushed = true;
        this.$router.push({ query: { ...this.$route.query, curve } });
    }

    removeCurveQuery(){
        if (!this.$route.query.curve) return;
        // Step back over the entry this component pushed, so closing the editor leaves no
        // trace in the history. Opened straight from a link there is no such entry, and
        // going back would leave the dashboard - the query is replaced instead.
        if (this.curve_query_pushed) {
            this.curve_query_pushed = false;
            this.$router.back();
            return;
        }
        const query = { ...this.$route.query };
        delete query.curve;
        this.$router.replace({ query });
    }

    setCurveData(curve_id?){
        if (this.curveClicked){
            this.dataCurve = curve_id
                ? this.userCurves.find((curve) => curve.id === curve_id)
                : null;
        }
    }
}

export default CurveSelection;
